/**
 * Created by piotr.pozniak@thebeaverhead.com on 10/12/2025.
 */

import React from "react";

import { IT } from "../../../../consts";
import classNames from "classnames";
import { useIntegrationsStore } from "../../../../hooks/redux/integrations";
import { formatDate } from "../../../../helpers/date";

/**
 *
 * @param {function} onChange
 * @param {boolean} disabled
 * @param {Array} allowedIntegrations
 * @param {Object|string} error
 * @param {string} selectedIntegrationUUID
 * @returns {React.JSX.Element}
 * @constructor
 */
const IntegrationSelect = ({
  onChange,
  disabled,
  allowedIntegrations = Object.values(IT),
  error,
  selectedIntegrationUUID,
}) => {
  const { integrations } = useIntegrationsStore();

  const integrationsOptions = integrations.collection.length
    ? integrations.collection
        .filter((i) => Number.parseInt(i.available))
        .filter((i) => allowedIntegrations.includes(i.type))
        .map((item) => {
          const creationDate = item?.created
            ? formatDate(new Date(item?.created * 1000))
            : "-";

          return (
            <option key={"integration-" + item.uuid} value={item.uuid}>
              {item.name} - {item.username} [{creationDate}]
            </option>
          );
        })
    : null;

  return (
    <div className="form-group">
      <div className="col-md-xs">
        <label htmlFor={"widget_integration_uuid"} className={""}>
          Integration
        </label>
        <select
          key={new Date().valueOf()}
          className={classNames("form-control", {
            "is-invalid": error,
          })}
          value={selectedIntegrationUUID}
          id="widget_integration_uuid"
          onChange={onChange}
          disabled={disabled}
        >
          <option value={0}>Select Integration...</option>
          {integrationsOptions}
        </select>
      </div>
    </div>
  );
};

export default IntegrationSelect;
